/* eslint-disable @typescript-eslint/no-non-null-assertion */
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { catchError, map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from './storage.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from './util.service';
import { type RateRenewal } from '../models/rate-renewal';
import { type Packages } from '../models/packages';

@Injectable({
  providedIn: 'root',
})
export class RateService {
  constructor(
    private readonly http: HttpClient,
    private readonly utilService: UtilService,
    private readonly storage: StorageService,
  ) {}

  getRenewalRatePackages(rateRenewalRequest: RateRenewal): Observable<Packages> {
    const url = environment.OASUrl() + '/rates/get-renewal-rate-packages';
    const res = this.http.post(url, rateRenewalRequest);
    return res.pipe(
      map((data: Packages) => {
        if (data.Error === null) {
          return data;
        } else {
          throw new Error(data.Error?.ErrorCode);
        }
      }),
    );
  }

  getUnathenticatedRenewalRatePackages(encryptedAccountNumber: string): Observable<Packages> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        ClientId: environment.ClientId,
      }),
    };
    const url = environment.OASUrl() + '/unauthrates/get-unauth-renewal-rate-packages?value=' + encryptedAccountNumber;
    const res = this.http.get(url, httpOptions);
    return res.pipe(
      map((data: Packages) => {
        if (data.Error === null) {
          return data;
        } else {
          throw new Error(data.Error?.ErrorCode);
        }
      }),
    );
  }

  getUnAuthenicatedPersonId(accountNumber: string): Observable<string> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        ClientId: environment.ClientId,
      }),
    };
    const url = environment.OASUrl() + '/unauthrates/get-unauth-personid?accountNumber=' + accountNumber;
    const res = this.http.get(url, httpOptions);
    return res.pipe(
      map((data: any) => {
        return data.personId;
      }),
      catchError((e) => {
        throw new Error(e);
      }),
    );
  }

  createCSR(csrRequest: any): Observable<any> {
    const url = environment.createCSRUrl() + '/UserAccounts/CreateCSR';
    const res = this.http.post(url, csrRequest, {
      headers: new HttpHeaders(environment.requestKeysAPP),
      responseType: 'json',
    });
    return res.pipe(
      map((data: any) => {
        if (data.length > 0) {
          if (data[0].ErrorStatus === 'N') {
            return data;
          }
        }
        throw new Error();
      }),
    );
  }

  getPoolGroupByPremiseId(premiseId: string): Observable<any> {
    const url = environment.createCSRUrl() + '/rates/GetPoolGroupByAGLPremise?premiseNumber=' + premiseId;
    const res = this.http.get(url, {
      headers: { ...environment.requestKeysAPP },
      responseType: 'json',
    });
    return res.pipe(
      map((data: any) => {
        return data;
      }),
      catchError((e) => {
        throw new Error(e);
      }),
    );
  }
}
